import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import momentTz from "moment-timezone";
import { SortAscDesc } from "typings/globalGQLTypes";

export enum ReportType {
  Buildings = "BUILDINGS",
  Individuals = "INDIVIDUALS",
}

export interface SortInput {
  // If column is '-1', then sort by the resource
  column: number;
  order: SortAscDesc;
}

interface ReportsState {
  buildingsSortInput: SortInput;
  dateEndAt: string | null;
  dateStartAt: string | null;
  individualsSortInput: SortInput;
  reportType: ReportType;
}

export const getReportsDateRange = (date = momentTz.tz()) => ({
  endAt: date.clone().endOf("day").toISOString(),
  startAt: date.clone().startOf("week").toISOString(),
});

const initialState: ReportsState = {
  buildingsSortInput: {
    column: -1,
    order: SortAscDesc.asc,
  },
  dateEndAt: getReportsDateRange().endAt,
  dateStartAt: getReportsDateRange().startAt,
  individualsSortInput: {
    column: -1,
    order: SortAscDesc.asc,
  },
  reportType: ReportType.Buildings,
};

const reportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    setBuildingsSortInput: (state, action: PayloadAction<SortInput>) => {
      state.buildingsSortInput = action.payload;
    },
    setDateEndAt: (state, action: PayloadAction<string | null>) => {
      state.dateEndAt = action.payload;
    },
    setDateStartAt: (state, action: PayloadAction<string | null>) => {
      state.dateStartAt = action.payload;
    },
    setIndividualsSortInput: (state, action: PayloadAction<SortInput>) => {
      state.individualsSortInput = action.payload;
    },
    setReportType: (state, action: PayloadAction<ReportType>) => {
      state.reportType = action.payload;
    },
  },
});

export const {
  setBuildingsSortInput,
  setDateEndAt,
  setDateStartAt,
  setIndividualsSortInput,
  setReportType,
} = reportsSlice.actions;

export default reportsSlice.reducer;
